function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { Input, Switch } from 'antd';
import { Icon } from '@ant-design/compatible';
import { Finder } from '../finder/finder';
import { TextMatchHighlight } from '../text-match-highlight/text-match-highlight';
import { getFriendlyPathName } from '../../utils/page-category-utils';
/**
 * Wraps the Finder component, providing PageCategory specific functionality.
 *
 * Basic Usage:
 *    <PageCategoryFinder
 *      pageCategories={pageCategories}
 *    />
 *
 *
 * The PageCategoryFinder manages it's own internal selection path even if the `selectedCategoryid` is initialized.
 * If `onCategorySelection` is used, the selected item id must be provided to update the components selected item display.
 *
 *    <PageCategoryFinder
 *      selectedCategoryId={selectedPageCategory ? selectedPageCategory.id : null}
 *      pageCategories={pageCategories}
 *      onCategorySelection{(pageCategory) => setSelectedPageCategory(pageCategory)}
 *    />
 *
 *
 * If `isEditable` is true, both `onAddCategory` and `onEditCategory` should be defined. The PageCategoryFinder does
 * not implement add/edit functionality itself. Updates must be reapplied to the category picker by sending updated
 * `pageCategories` in the component props.
 *
 *    <PageCategoryFinder
 *      pageCategories={pageCategories}
 *      isEditable={true}
 *      onAddCategory={(parentCategory) => {
 *          ...
 *      }}
 *      onEditCategory={(pageCategory) => {
 *          ...
 *      }}
 *    />
 *
 */

export var PageCategoryFinder = function PageCategoryFinder(props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selectedCategoryId = _useState2[0],
    setSelectedCategoryId = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    searchValue = _useState4[0],
    setSearchValue = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    finderData = _useState6[0],
    setFinderData = _useState6[1];
  var _useState7 = useState(props.showEmpty === true),
    _useState8 = _slicedToArray(_useState7, 2),
    showEmpty = _useState8[0],
    setShowEmpty = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    visibleCategories = _useState10[0],
    setVisibleCategories = _useState10[1];
  if (showEmpty && !props.subscriberCounts) {
    console.warn("PageCategoryFinder was configured with showEmpty={".concat(showEmpty, "} but no") + ' subscriberCounts were provided.');
  }
  useEffect(function () {
    // Limit the visible categories to what is not archived
    var visibleCategories = props.pageCategories;
    if (!props.showArchived) {
      visibleCategories = visibleCategories.filter(function (pc) {
        return !pc.destroyed_at;
      });
    }
    if (props.subscriberCounts && !showEmpty) {
      var _props$subscriberCoun;
      // Limit the visible categories to what what we have counts for
      var categoriesWithCounts = new Set();
      (_props$subscriberCoun = props.subscriberCounts) === null || _props$subscriberCoun === void 0 ? void 0 : _props$subscriberCoun.forEach(function (sc) {
        categoriesWithCounts.add(sc.category_id);
      });
      visibleCategories = visibleCategories.filter(function (vc) {
        return categoriesWithCounts.has(vc.id);
      });
    }

    // The selected category id may no longer be visible because it lost subscribers or was archived.
    // Ensure the path still exists
    var selectionId = selectedCategoryId || props.selectedCategoryId;
    if (selectionId) {
      var hand = props.pageCategories.find(function (pc) {
        return pc.id === selectionId;
      });
      while (hand) {
        if (!visibleCategories.includes(hand)) {
          visibleCategories.push(hand);
          hand = props.pageCategories.find(function (pc) {
            return pc.id === hand.parent_id;
          });
        } else {
          break;
        }
      }
    }
    setVisibleCategories(visibleCategories);
  }, [props.pageCategories, props.showArchived, showEmpty]);
  useEffect(function () {
    setFinderData(buildFinderTree(visibleCategories));
  }, [visibleCategories]);
  var render = function render() {
    return /*#__PURE__*/React.createElement(Finder, {
      data: finderData || [],
      selectedItemId: props.selectedCategoryId ? props.selectedCategoryId : selectedCategoryId,
      maxVisualDepth: props.maxVisualDepth,
      showBreadcrumbs: !searchValue,
      headerRender: renderHeader,
      finderRender: searchValue ? renderFinderSearch : undefined,
      itemRender: renderItem,
      showEmptyColumns: props.isEditable,
      onItemSelection: function onItemSelection(item) {
        props.onCategorySelection ? props.onCategorySelection(item === null || item === void 0 ? void 0 : item.pageCategory) : setSelectedCategoryId(item === null || item === void 0 ? void 0 : item.id);
      },
      columnFooterRender: props.isEditable && !searchValue ? function (parentItem, selectedItem) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, props.onAddCategory && /*#__PURE__*/React.createElement("a", {
          onClick: function onClick(_) {
            props.onAddCategory(parentItem === null || parentItem === void 0 ? void 0 : parentItem.pageCategory);
          }
        }, "Add Category"), selectedItem && selectedItem.pageCategory.domain_id && props.onEditCategory && /*#__PURE__*/React.createElement("a", {
          onClick: function onClick(_) {
            return props.onEditCategory(selectedItem.pageCategory);
          }
        }, "Edit"));
      } : undefined
    });
  };
  function renderHeader() {
    return /*#__PURE__*/React.createElement("div", {
      className: "page-category-picker-header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "page-category-title"
    }, props.title), props.subscriberCounts && props.showEmpty === 'toggle' && /*#__PURE__*/React.createElement("div", {
      className: "page-category-picker-toggle"
    }, /*#__PURE__*/React.createElement(Switch, {
      size: "small",
      checked: showEmpty,
      onChange: function onChange() {
        setShowEmpty(!showEmpty);
      }
    }), "Show Empty Categories"), /*#__PURE__*/React.createElement("div", {
      className: "page-category-picker-search"
    }, /*#__PURE__*/React.createElement(Input, {
      placeholder: "Search",
      width: 240,
      value: searchValue,
      onChange: function onChange(e) {
        return setSearchValue(e.target.value);
      }
    }), !searchValue && /*#__PURE__*/React.createElement(Icon, {
      className: "search-input-icon search",
      type: "search"
    }), searchValue && /*#__PURE__*/React.createElement(Icon, {
      onClick: function onClick(_) {
        return setSearchValue(undefined);
      },
      className: "search-input-icon close",
      type: "close"
    })));
  }
  function renderFinderSearch() {
    var matchingCategories = searchValue ? visibleCategories.filter(function (pc) {
      return RegExp(searchValue, 'i').test(pc.name);
    }) : [];
    return /*#__PURE__*/React.createElement("ul", {
      className: "page-category-picker-search-results"
    }, matchingCategories && matchingCategories.length ? matchingCategories.map(function (mc) {
      return /*#__PURE__*/React.createElement("li", {
        key: mc.id
      }, /*#__PURE__*/React.createElement("a", {
        onClick: function onClick(_) {
          setSearchValue(undefined);
          props.onCategorySelection ? props.onCategorySelection(mc) : setSelectedCategoryId(mc.id);
        }
      }, /*#__PURE__*/React.createElement(TextMatchHighlight, {
        text: getFriendlyPathName(props.pageCategories, mc),
        highlightText: searchValue
      })));
    }) : /*#__PURE__*/React.createElement("li", null, "No Results Found"));
  }
  function renderItem(item, _) {
    return /*#__PURE__*/React.createElement("div", {
      className: "page-category-finder-item"
    }, /*#__PURE__*/React.createElement("span", {
      className: "page-category-finder-item-name"
    }, item.label), item.children && item.children.length > 0 && /*#__PURE__*/React.createElement("span", {
      className: "page-category-finder-item-children-count"
    }, "(", item.children.length, ")"), /*#__PURE__*/React.createElement("span", {
      className: "page-category-finder-item-flags"
    }, item.pageCategory.destroyed_at && /*#__PURE__*/React.createElement("span", {
      className: "page-category-finder-item-archived"
    }, "Archived"), item.pageCategory.domain_id && /*#__PURE__*/React.createElement("span", {
      className: "page-category-finder-item-custom"
    }, "Custom")));
  }
  return render();
};

/**
 * Transforms the flat page categories array into a tree
 */
function buildFinderTree(pageCategories) {
  var parentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var finderTree = [];
  var childCategories = pageCategories.filter(function (pc) {
    return pc.parent_id === parentId;
  });
  var _iterator = _createForOfIteratorHelper(childCategories),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var childCategory = _step.value;
      finderTree.push({
        id: childCategory.id,
        label: childCategory.name,
        pageCategory: childCategory,
        children: buildFinderTree(pageCategories, childCategory.id)
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return finderTree;
}